var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coffee-search-wrapper"},[_vm._m(0),_vm._v(" "),_c('input',{ref:"input",staticClass:"coffee-search-input",attrs:{"type":"text","placeholder":"Search"},on:{"input":function($event){return _vm.valueChanged($event.target.value)}}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fas fa-search"})])
}]

export { render, staticRenderFns }